// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  /** Whether to apply margin to the top */
  $marginTop?: boolean,
  /** Whether to apply full width */
  $fullWidth?: boolean,
  /** The padding on the top */
  $paddingTop?: '0' | '4' | '8' | '16',
  /** Whether to apply padding on mobile */
  $noPaddingOnMobile?: boolean,
}

const StyledContainer: React.ComponentType<Props> = tw.div`
  container
  p-16
  overflow-auto

  ${(props: Props) => {
    if (!props.$marginTop) {
      return ''
    }
    return 'mt-5'
  }}

  ${(props: Props) => {
    if (props.$fullWidth) return 'h-full'

    return ''
  }}

  ${(props: Props) => {
    if (!props.$paddingTop) return ''

    return `pt-${props.$paddingTop}`
  }}

  ${(props: Props) => {
    if (!props.$noPaddingOnMobile) return ''

    return `
      p-none
      md:p-16
    `
  }}
`

/** A container for content, applying margin and padding */
const Container = (props: Props): React.Node => <StyledContainer {...props} />

export default Container
